export default function OfferwallPage() {

  return (
    <section>

    </section>
  )
}